module.exports = __webpack_public_path__ + "img/templates.82927646.png";